export {
    BrowserRouter as Router,
    Link,
    Route,
    Switch,
    withRouter
} from 'react-router-dom';